import { render, staticRenderFns } from "./ParentFeedback.vue?vue&type=template&id=42d11cb6&scoped=true"
import script from "./ParentFeedback.vue?vue&type=script&lang=js"
export * from "./ParentFeedback.vue?vue&type=script&lang=js"
import style0 from "./ParentFeedback.vue?vue&type=style&index=0&id=42d11cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d11cb6",
  null
  
)

export default component.exports